import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    order: {
      boxShadow: '0px 2px 4px 0px #0000001A',
      borderRadius: '1.25rem',
      padding: '0.625rem',
      backgroundColor: '#FFFFFF',
    },
    orderContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 1.375rem 0.5rem 1.375rem',
    },
    item: {
      fontWeight: 420,
      margin: '0.5rem 0',
    },
    subItem: {
      fontWeight: 300,
      margin: '0.5rem 0',
    },
    contentImage: {
      width: '10rem',
      height: '10rem',
      display: 'flex',
      justifyContent: 'center',
      background: '#F5F8FA',
      borderRadius: '0.675rem',
      alignItems: 'center',
      boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.15)',
      marginBottom: '0.5rem',
      '& svg': {
        width: '8rem',
        height: '8rem',
      },
    },
    copyCodeButton: {
      width: '10rem',
      borderRadius: '0.75rem',
      padding: '0.5rem',
      textTransform: 'none',

      '&:hover': {
        background: '#0094FF',
        filter: 'brightness(0.9)',
      },

      background: '#0094FF',
      color: ' #fff',
    },
    seatType: {
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        '& p': {
          fontWeight: 500,
        },
        '& svg path': {
          fill: '#0094FF',
        },
      },
    },
  }),
);

export default useStyles;
